const ACTIVE_LOCALES = new Set([
  "en",
  "bg",
  "el",
  "es",
  "fr",
  "pt",
  "pl",
  "de",
  "tr",
]);

export function resolvePushRegistrationLocale(language) {
  const locale = String(language || "")
    .trim()
    .toLowerCase()
    .split("-")[0];
  return ACTIVE_LOCALES.has(locale) ? locale : "en";
}

export function detectPushRegistrationTimezone(intl = Intl) {
  try {
    const timezone = intl?.DateTimeFormat?.().resolvedOptions?.().timeZone;
    if (typeof timezone !== "string" || !timezone.trim()) return null;
    new intl.DateTimeFormat("en", { timeZone: timezone.trim() }).format();
    return timezone.trim();
  } catch {
    return null;
  }
}

export function buildPushRegistrationMetadata(capability, language) {
  return {
    platform: capability?.platform === "twa" ? "twa" : "web",
    appContext: ["browser", "standalone", "twa"].includes(
      capability?.appContext
    )
      ? capability.appContext
      : "browser",
    permissionState: "granted",
    locale: resolvePushRegistrationLocale(language),
    timezone: detectPushRegistrationTimezone(),
    appVersion: null,
    deviceLabel: null,
  };
}
